<template>
    <div class="row justify-content-center">
        <div class="callout callout-success bg-success">
            <h6><b><i class="fa fa-shield"></i></b>
                Insira o Token de confirmação que foi enviado para seu <span v-if="tokenTipo == 'M'">Celular</span> <span v-else>E-mail</span>
                
               </h6>
                <button role="button" :disabled="loading" class="btn btn-sm text-white" style="border:1px solid" @click="resendToken()"><i class="fa fa-reply"></i> Reenviar</button>
        </div>
        <v-otp-input ref="otpInput" input-classes="otp-input" separator="-" :num-inputs="5" :should-auto-focus="true"
            :is-input-num="true" @on-change="handleOnChange" @on-complete="handleOnComplete" />
        <button class="d-md-block d-none btn btn-outline-danger" @click="handleClearInput()"><i class="fa fa-trash"></i></button>
       
    </div>
</template>
<script>
    export default {
        props: {
            tokenTipo: String
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            handleOnComplete(value) {
                this.$emit('changed', value)
            },
            handleOnChange(value) {
                this.$emit('changed', null)
            },
            handleClearInput() {
                this.$refs.otpInput.clearInput();
            },
            resendToken() {
                this.loading = true;
                this.$store.dispatch('resendTokenOtp', this.$route.params.id).then(response => {
                    toastr({
                        title: response.message,
                        icon: response.status
                    });
                }).catch(error => {
                    toastr({
                        title: error.message,
                        icon: error.status
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style lang="css">
    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
    }

    .otp-input.error {
        border: 1px solid red !important;
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>